import React from 'react';
import {Button, Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button as SementicBtn, Checkbox, Dropdown, Form, Icon, Input, List, Message} from "semantic-ui-react";
import TxtLbl from "../../../components/Input/Input/TxtLbl";
import TxtAreaLbl from "../../../components/Input/TextArea/TextAreaLbl";
import {DatePicker, message, Spin, Tooltip} from 'antd';
import Lbl from "../../../components/Label/Lbl";
import './style.css';
import $ from "jquery";
import * as DropDownConst from "../../../store/Reducer/DropDownConst";
import IntlTelInput from "react-intl-tel-input";
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import moment from "moment";
import * as EmailValidator from "email-validator";
import * as common from "../../../const/Common/CommonFunc";
import {notifyMessage} from "../../../const/Common/CommonFunc";
import * as util from "../../../util/Validator";
import Cookies from "js-cookie";
import apiConfig from "../../../axios/axios_api_services";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import Job from '../../../components/IcsFileGenerator/ics';
import building_icon from "../../../assets/img/recept_checkin/building.svg";
import LabelInput from "../../../components/Input/LabelInput/LabelInput";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import axios from "../../../axios/axios_visitortag";
import floor_icon from "../../../assets/img/recept_checkin/floor.svg";
import axiosTags from "../../../axios/axios_tag";
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import ModernTimePicker from "../../../components/TimePicker";
import csvFormat from "../../../assets/csv/csv_bulk_visitors_search.csv";
import Files from "react-files";
import base64 from "base-64";

function formatDate() {
  var d = new Date(),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}

function disabledDate(current) {
  return current < moment().subtract(1, "days").endOf("day");
}


class App extends React.Component {

  constructor(props) {
    super(props);
    this.observer = null;
  }

  state = {
    // B09854567
    hostId: "",
    hostName: "",

    meetingTitle: "",
    meetingDescription: "",
    meetingDate: "",
    meetingSTime: "",
    meetingETime: "",
    meetingBuilding: "",
    meetingBuildingId: "",
    meetingFloor: "",
    meetingPurpose: "",
    meetingFrequency: "",
    meetingUntil: "",

    attendeeChange: true,
    attendeeUserId: 0,
    attendeeCorpId: 0,
    attendeeSearch: "",
    attendeeType: "NIC",
    attendeeTitle: "Mr",
    attendeeIdentity: "",
    attendeeFName: "",
    attendeeLName: "",
    attendeeMobile: "",
    attendeeCompany: "",
    attendeeEMail: "",

    attendeeValidMobile: false,
    attendeeValidEMail: false,
    attendeeValidIdentity: true,

    repeatOpen: false,
    attendeesList: [],
    meetingFloorList: [],

    valid_search_mobile:false,
    search_mobile:'',
    attendeeIdentifyType:'NIC',
    searchOptions: DropDownConst.IdentificationsHostWithoutVN,
    attendeeVehicleNo:'',
    attendeeRemark:'',
    validVehicleNo:false,
    enable_overdue: true,

    visitor_info_type: 'ADULT',
    children_list: [],
    search_mode: false,
    mobile_confirmation_condi:false,

    attendeeErrors: [],
    s_visible: false,
    e_visible: false,
    bulkVisitorsModalOpen: false,
    isSpin: false,
    json: [],
    errorjson: [],
    validationErrors: [],
    visitors_bulk_rows: [],
    visitors_validation_error_rows: [],
    limitationError: "",
  }


  disabledDateForUntil = (current) => {
    if (this.state.meetingDate !== '') {
      return current < moment(this.state.meetingDate, "YYYY-MM-DD").add(1, 'days');
    }

  }

  componentWillMount() {
    // this.props.callAllBuildings(this.props.usr_obj);
  }

  componentDidMount() {
    if (this.props.usr_obj !== null || this.props.usr_obj !== "") {
      // this.props.history.push("/host/login");
    }
    this.props.callAllBuildings(this.props.usr_obj);
    this.setState({hostId: this.props.usr_obj.userId});
    this.observer = new MutationObserver(this.handleTableMutation)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let {bulkVisitorsModalOpen,json} = this.state;

    if (bulkVisitorsModalOpen !== prevState.bulkVisitorsModalOpen) {
      if (bulkVisitorsModalOpen) {
        this.observer.observe(document.getElementById('bulk-visitors-tbl'),{childList: true, subtree: true, characterData: true});
      } else {
        this.observer.disconnect();
      }
    }
  }

  handleTableMutation = (mutationList) => {
    $("#bulk-visitors-tbl > tbody > tr").css("background-color", "white");
    if (this.state.visitors_validation_error_rows !== 0) {
      this.state.visitors_validation_error_rows.map((error, index) => {
        $("#bulk-visitors-tbl > tbody > tr").each(function () {
          if ($(this).find('td').eq(0).text() === error.cellNumber.toString()) {
            $(this).css("background-color", "rgb(255,162,162)");
          }
        })
      })
    }
    if (this.state.errorjson.length !== 0) {
      this.state.errorjson.map((error,index) => {
        $("#bulk-visitors-tbl > tbody > tr").each(function () {
          if ($(this).find('td').eq(0).text() === error.row.toString()) {
            $(this).css("background-color", "rgb(255,162,162)");
          }
        })
      })
    }
  }

  onHandleChangeAttendeeChange = () => {
    // common.notifyMessage("You can't change attendee details");
  }

  callAllBuildings = (usr_obj) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let coperateId = usr_obj.corporates[0].corporateId;

    // Get All Buildings Of Corporate
    axiosTags.get(apiConfig.CORPORATE_BUILDINGS(coperateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          // dispatch(receptionAllBuildingHandler(response.data.buildingList));
        }
      })
      .catch(error => {
        // dispatch(checkErrorResponse(error, usr_obj, 1));
      });
  };

  changeRepeatOpen = () => {
    this.setState({
      repeatOpen: !this.state.repeatOpen
    });
  }

  onHandleChange = name => e => {
    let value = e.target.value;
    switch (name) {
      case "attendeeSearch":
        this.setState({attendeeSearch: value});
        break;
      case "meetingTitle":
        this.setState({meetingTitle: value});
        break;
      case "meetingDescription":
        if (value.length <= 20000) {
          this.setState({meetingDescription: value, limitationError: ""});
        } else {
          this.setState({limitationError: "Description limit exceeded"})
        }
        break;
      case "attendeeIdentity":
        this.setState({attendeeIdentity: value});
        break;
      case "attendeeFName":
        this.setState({attendeeFName: value});
        break;
      case "attendeeLName":
        this.setState({attendeeLName: value});
        break;
      case "attendeeCompany":
        this.setState({attendeeCompany: value});
        break;
      case "attendeeEMail":
        let validateEmail = EmailValidator.validate(value);
        this.setState({attendeeEMail: value, attendeeValidEMail: validateEmail});
        break;
      case "attendeeVehicleNo":
        let validateVehicleNo_ = util.vehicleNumberPlateValidation(value);
        this.setState({attendeeVehicleNo:value, validVehicleNo:validateVehicleNo_}); break;
      case "attendeeRemark":
        this.setState({attendeeRemark: value}); break;
      default:
        break;
    }
  }

  handleOverdueStatus = () => {
    this.setState({
      enable_overdue: !this.state.enable_overdue
    })
  }

  onHandleChangeFloor = (e, {value}) => {
    this.setState({
      meetingFloor: value
    });
  };

  onHandleChangePurpose = (e, {value}) => {
    this.setState({
      meetingPurpose: value
    });
  };

  onHandleChangeAttendeeTitle = (e, {value}) => {
    if (this.state.attendeeChange) {
      this.setState({
        attendeeTitle: value
      });
    }
  };

  onHandleChangeMeetingFrequency = (e, {value}) => {
    this.setState({meetingFrequency: value})
  }

  onHandleMeetingDate = (date, dateString) => {
    let dateRange = moment("");
    this.setState({meetingDate: dateString});
  }

  onHandleChangeSTime = (time, timeString) => {
    this.setState({meetingSTime: timeString + ":00"});
  }

  onHandleChangeETime = (time, timeString) => {
    this.setState({meetingETime: timeString + ":00"});
  }

  onHandleChangeUntil = (until, untilString) => {
    this.setState({meetingUntil: untilString});
  }

  onHandleChangeBuilding = (e, {value}) => {
    let selectedMeetingBuilding = this.props.all_building_list[value];
    let floor_options = [];
    if (selectedMeetingBuilding.floors.length !== 0) {
      selectedMeetingBuilding.floors.map((element, index) => {
        floor_options.push({
          key: element.floor_id,
          text: element.description,
          value: element.floor_id,
          image: {avatar: true, src: floor_icon},
        })
      })
    }
    this.setState({
      meetingFloorList: floor_options,
      meetingBuildingId: selectedMeetingBuilding.buildingId,
      meetingBuilding: value
    });
  }

  onHandleChangeAttendeeSearch = e => {

  }

  onHandleChangeAttendeeMobile = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcode.substr(1).replace(/\s/g, ""),condition);
    this.setState({attendeeMobile: value, attendeeValidMobile: condition});
  }

  onHandleCustomPlaceholderForAttendeeMobile = (selectedCountryPlaceholder, selectedCountryData) => {
    // return selectedCountryData.dialCode + "XXXXXXXXXX";
    return "7XXXXXXXXX";
  }

  addAttendeeIntoQueue = () => {
    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    let {attendeeUserId, attendeeIdentity, attendeeCorpId} = this.state;
    if (this.state.visitor_info_type === 'ADULT') {
      let isValidIdentify;
      if(attendeeUserId && (corporateId === attendeeCorpId) && attendeeIdentity.trim() === "") {
        isValidIdentify = true;
      }else{
        isValidIdentify = util.identityValueValidator(attendeeIdentity.trim(), this.state.attendeeIdentifyType)
      }

      if (isValidIdentify) {
        this.state.attendeeFName.trim() === '' ? common.notifyMessage("Please enter attendee first name") :
          this.state.attendeeLName.trim() === '' ? common.notifyMessage("Please enter attendee last name") :
            // attendeeIdentity.trim() === '' ? common.notifyMessage("Please enter attendee identification") :
              !this.state.attendeeValidIdentity ? common.notifyMessage("Please enter valid identification for attendee") :
                this.state.attendeeMobile.trim() === '' ? common.notifyMessage("Please enter attendee mobile") :
                  !this.state.attendeeValidMobile ? common.notifyMessage("Please enter valid mobile for attendee") :
                    this.state.attendeeVehicleNo.trim() !== '' && !this.state.validVehicleNo? common.notifyMessage("Please enter valid vehicle number for attendee"):
                      this.state.children_list.length !== 0 ? this.addChildrenAction('save') : this.testMailValidation();
                      // this.state.attendeeCompany.trim().match(/[|\\/~^:,;?!&%$@*+]/)? common.notifyMessage("Please enter valid attendee company"):

      }
    } else {
      this.addChildrenAction('save')
    }
  }

  testMailValidation = () => {
    if (this.state.attendeeEMail.trim() !== '') {
      if (!this.state.attendeeValidEMail) {
        common.notifyMessage("Please enter attendee email")
      } else {
        this.addAttendeeIntoQueueAdvanceValidate();
      }
    } else {
      this.addAttendeeIntoQueueAdvanceValidate();
    }
  }


  addAttendeeIntoQueueAdvanceValidate = () => {
    this.addAttendeeIntoQueue_();
    // let a_id = this.state.attendeeIdentity;
    // let u_id = this.props.usr_obj.identificationValue;
    // if (a_id !== u_id) {
    //   this.addAttendeeIntoQueue_();
    // } else {
    //   common.notifyMessage("Can't add host into attendee queue");
    // }
  }

  addAttendeeIntoQueue_ = () => {

    if (!this.state.mobile_confirmation_condi) {

      swal({
        className: "swal-reception-number-check",
        text: "Please verify the mobile number of the attendee: " + this.state.attendeeMobile,
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Incorrect',
          dangerMode: {
            text: "Correct",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {

      switch (value) {
          case "action":
            this.addAttendeeIntoQueue__();
            break;
          default:
            break;
        }
      });

    } else {
      this.addAttendeeIntoQueue__();
    }

  }

  addAttendeeIntoQueue__ = () => {
    let attendeesList = this.state.attendeesList;
    let valid = true;
    for (let key in attendeesList) {
      let obj = attendeesList[key];
      if (this.state.attendeeIdentity !== null && this.state.attendeeIdentity.trim() !== "" && obj.identificationValue === this.state.attendeeIdentity) {
        common.notifyMessage("An attendee is already in attendees queue with this identification. Please try another one");
        valid = false;
        break;
      } else if (obj.mobile === this.state.attendeeMobile) {
        common.notifyMessage("An attendee is already in attendees queue with this mobile. Please try another one");
        valid = false;
        break;
      } else if ((this.state.attendeeEMail !== undefined && this.state.attendeeEMail !== null && this.state.attendeeEMail !== "") && (obj.email === this.state.attendeeEMail)) {
        common.notifyMessage("An attendee is already in attendees queue with this email. Please try another one");
        valid = false;
        break;
      }
    }
    if (valid) {
      this.addAttendeeIntoQueue___();
    }
  }

  addAttendeeIntoQueue___ = async () => {

    let children = []
    if (this.state.children_list.length !== 0 && this.state.visitor_info_type === 'ADULT') {
      this.state.children_list.map(item => {
        children.push({
          title: item.title,
          firstName: item.firstName,
          lastName: item.lastName,
          visitorType: 'CHILD'
        })
      })
    }

    let obj = {
      userId: this.state.attendeeUserId,
      title: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeTitle : this.state.children_list[0].title,
      identificationValue: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeIdentity : null,
      identificationType: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeIdentifyType : null,
      firstName: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeFName.trim() : this.state.children_list[0].firstName.trim(),
      lastName: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeLName.trim() : this.state.children_list[0].lastName.trim(),
      mobile: this.state.attendeeMobile ? this.state.attendeeMobile.trim() : null,
      companyName: this.state.attendeeCompany?this.state.attendeeCompany.trim() : null,
      email: this.state.attendeeEMail?this.state.attendeeEMail.trim() : null,
      vehicleNumber: this.state.attendeeVehicleNo.trim() !== '' ? this.state.attendeeVehicleNo.trim().toUpperCase() : '',
      remark: this.state.attendeeRemark,
      enableOverdueSms: this.state.visitor_info_type === 'CHILD' ? false : this.state.enable_overdue,
      visitorType:this.state.visitor_info_type,
      children:this.state.visitor_info_type === 'ADULT' ? children : []
    };
    let attendeesList = this.state.attendeesList;
    this.state.visitor_info_type === 'CHILD' ? attendeesList = [obj] : attendeesList.push(obj)
    // if (!(this.state.visitor_info_type === 'CHILD' && this.state.attendeesList.length !== 0)) attendeesList.push(obj);
    await this.setState({attendeesList: attendeesList, attendeeChange: true, attendeeSearch:'', valid_search_mobile:false,
      search_mobile:'', attendeeIdentifyType:'NIC', mobile_confirmation_condi:false, search_mode:false,
      children_list: this.state.visitor_info_type === 'ADULT' ? [] : this.state.children_list });
    this.cleanAttendeeFields();

    if (this.state.visitor_info_type === 'CHILD') this.submit()

  }

  removeAttendeeFormList = (index, attendee) => {
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to remove attendee named " + attendee.firstName + " with mobile number " + attendee.mobile + " from queue?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {

      switch (value) {
        case "action":
          this.removeAttendeeFormList_(index);
          break;
        default:
          break;
      }
    });
  }

  removeAttendeeFormList_ = (index) => {
    let attendeeArray = this.state.attendeesList;
    let attendErrors = this.state.attendeeErrors;
    attendErrors.map((error,ind) => {
      if (error.row === (index+1)) {
        attendErrors.splice(ind, 1);
      }
    })
    attendeeArray.splice(index, 1);
    this.setState({
      attendeesList: attendeeArray,
      attendeeErrors: attendErrors
    });
  }

  //$#$#
  cleanAttendeeFields = () => {
    this.setState({
      attendeeTitle: "Mr",
      // attendeeSearch: "",
      attendeeType: this.state.attendeeType,
      attendeeIdentity: "",
      attendeeFName: "",
      attendeeLName: "",
      attendeeMobile: "",
      attendeeCompany: "",
      attendeeEMail: "",
      attendeeValidMobile: false,
      attendeeValidEMail: false,
      attendeeValidIdentity: true,
      attendeeIdentifyType:'NIC',
      attendeeVehicleNo:'',
      attendeeRemark:'',
      validVehicleNo:false,
      enable_overdue: true,
      json: [],
      errorjson: [],
      validationErrors: [],
      visitors_bulk_rows: [],
      visitors_validation_error_rows: []
    });
    $("#bulk-visitors-tbl > tbody > tr").css("background-color", "white");
  }

  cleanAttendeeTbl = () => {
    this.setState({attendeesList: [], attendeeErrors: []});
  }

  cleanMeetingFields = () => {
    this.setState({
      attendeeChange: true,
      attendeeSearch: "",
      meetingTitle: "",
      meetingDescription: "",
      limitationError: "",
      meetingDate: "",
      meetingSTime: "",
      meetingETime: "",
      meetingBuilding: "",
      meetingFloor: "",
      meetingPurpose: "",
      meetingFrequency: "",
      meetingUntil: "",
      repeatOpen: false
    });
  }

  searchAttendeeTypeChange = e => {
    this.setState({
      attendeeType: e.target.value
    });
  }

  searchAttendeeUsingIdentity = () => {

    let identity = this.state.attendeeSearch.trim();
    let isValidIdentity = false;
    if (this.state.attendeeType === "NIC" || this.state.attendeeType === "Passport" || this.state.attendeeType === "Driving Licence") {
      isValidIdentity = util.identityValueValidator(identity, this.state.attendeeType);
    } else if (this.state.attendeeType === "Mobile") {
      this.state.valid_search_mobile ? isValidIdentity = true : common.notifyMessage("Please add a valid mobile number.");
    } else if (this.state.attendeeType === "Email") {
      EmailValidator.validate(identity) ? isValidIdentity = true : common.notifyMessage("Please add a valid email.");
    } else {
      isValidIdentity = true;
    }

    let valid = isValidIdentity ? this.searchDuplicatesInMeetingQueue() : false;

    if (isValidIdentity && valid) {
      this.setState({ search_mode: true })
      this.cleanAttendeeFields();
      this.props.spinnerHandler(true);
      const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};
      // const headers = {'Content-Type': 'application/json', "Authorization": "Bearer " + "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiJjdF9rYXZpbmR1Iiwic2NvcGUiOlsicmVhZCIsIndyaXRlIiwidHJ1c3QiXSwiZXhwIjoxNTk1OTMxNTAxLCJ1c2VyIjp7InVzZXJJZCI6MzUsInVzZXJOYW1lIjoiY3Rfa2F2aW5kdSIsImZ1bGxOYW1lIjoiS2F2aW5kdSBBa2FzaCBTYW1hcmFzaW5naGUiLCJlbWFpbCI6Im5ld3RlY2hzb2lsZGVyQGdtYWlsLmNvbSIsInN0YXR1cyI6MSwidXNlclJvbGVzIjoiUkVDRVBUSU9OIiwiY29ycG9yYXRlcyI6W3siY29ycG9yYXRlSWQiOjEsImNvcnBvcmF0ZUNvZGUiOiJDMDAxIiwiY29ycG9yYXRlTmFtZSI6IkNleWVudHJhIFRlY2hub2xvZ2llcyJ9XSwic2VydmljZXMiOlt7InNlcnZpY2VJZCI6MSwic2VydmljZU5hbWUiOiJQYXJrVGFnIFNlcnZpY2UifSx7InNlcnZpY2VJZCI6Miwic2VydmljZU5hbWUiOiJWaXNpdG9yVGFnIFNlcnZpY2UifV19LCJhdXRob3JpdGllcyI6WyJST0xFX1JFQ0VQVElPTiJdLCJqdGkiOiJlYWExMjAyYy1lYjA0LTQ5NTYtYjFhZi0xMTRhNzhhMWJiYTkiLCJjbGllbnRfaWQiOiJjZXllbnRyYSJ9.wOEaoPOlSjpVpfGDtvjYECIzW9lwolPtWYurY8SgTQQ"};

      let corporateId = this.props.usr_obj.corporates[0].corporateId;
      // let corporateId = 1;
      axios.get(apiConfig.CORPORATE_VISITOR_IDENTIFY_SEARCH({
        corporateId: corporateId,
        identifyValue: identity,
        searchType: this.state.attendeeType === "Mobile" ? `mobile` : this.state.attendeeType === "Email" ? 'email' : undefined
      }), {headers: headers})
        .then(response => {
          if (response.data.success) {
            let res = response.data.visitorList;
            if (res === undefined) {
              if (response.data.visitor !== undefined) {
                let visitor = response.data.visitor.visitor;
                this.setState({ attendeeChange: false, mobile_confirmation_condi:true });
                this.selectAttendee(visitor);
              }
            } else if (res.length !== 0) {
              let attendee = res[0];
              this.setState({attendeeChange: false, mobile_confirmation_condi:true });
              this.selectAttendee(attendee.visitor);
            }
          } else {
            this.setState({
              attendeeIdentity: !(this.state.attendeeType === 'Mobile' || this.state.attendeeType === 'Email') ? this.state.attendeeSearch.trim() : "",
              attendeeUserId: 0,
              attendeeCorpId: 0,
              attendeeChange: true,
              attendeeMobile: this.state.attendeeType === 'Mobile' ? this.state.search_mobile.trim() : "",
              attendeeEMail: this.state.attendeeType === 'Email' ? this.state.attendeeSearch.trim() : "",
              attendeeValidMobile: this.state.attendeeType === 'Mobile',
              attendeeValidEMail: this.state.attendeeType === 'Email',
              attendeeIdentifyType: this.state.attendeeType === 'Mobile' || this.state.attendeeType === 'Email' ? 'NIC' : this.state.attendeeType
            })
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.searchAttendeeUsingIdentity()
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        })
    }

  };

  searchDuplicatesInMeetingQueue = () => {
    let attendeesList = this.state.attendeesList;
    let valid = true;
    for (let key in attendeesList) {
      let obj = attendeesList[key];
        if ((this.state.attendeeType === "NIC" || this.state.attendeeType === "Driving Licence" || this.state.attendeeType === "Passport") && obj.identificationValue.toLowerCase() === this.state.attendeeSearch.toLowerCase()) {
          common.notifyMessage("An attendee is already in attendees queue with this identification. Please try another one");
          valid = false;
          break;
        } else if (this.state.attendeeType === "Mobile" && (obj.mobile === this.state.search_mobile || obj.mobile.replace(/^0/, "") === this.state.search_mobile || obj.mobile === this.state.search_mobile.replace(/^0/, ""))) {
          common.notifyMessage("An attendee is already in attendees queue with this mobile. Please try another one");
          valid = false;
          break;
        } else if (this.state.attendeeType === "Email" && obj.email === this.state.attendeeSearch) {
          common.notifyMessage("An attendee is already in attendees queue with this email. Please try another one");
          valid = false;
          break;
        }
    }
    return valid;
  }

  selectAttendee = (attendee) => {
    let userId = attendee.userId;

    let attendeeIdentity = attendee.identificationValue === null || attendee.identificationValue === undefined ? this.state.attendeeIdentity : attendee.identificationValue;
    let attendeeCompany = attendee.companyName === null || attendee.companyName === "" || attendee.companyName === undefined ? "-" : attendee.companyName;
    let attendeeEMail = attendee.email === null || attendee.email === "" || attendee.email === undefined ? "" : attendee.email;
    let attendeeFName = attendee.firstName === null || attendee.firstName === "" || attendee.firstName === undefined ? "-" : attendee.firstName;
    let attendeeLName = attendee.lastName === null || attendee.lastName === "" || attendee.lastName === undefined ? "-" : attendee.lastName;
    let attendeeTitle = attendee.title === null || attendee.title === undefined ? "Mr" : attendee.title;
    let attendeeMobile = attendee.mobile === null || attendee.mobile === "" || attendee.mobile === undefined ? "" : attendee.mobile;
    let identificationType = (attendee.identificationType === null ||  attendee.identificationType === "") && (this.state.attendeeType === 'Mobile' || this.state.attendeeType === 'Email') ? 'NIC' :
      (attendee.identificationType === null ||  attendee.identificationType === "") && !(this.state.attendeeType === 'Mobile' || this.state.attendeeType === 'Email') ? this.state.attendeeType : attendee.identificationType;
    let attendeeValidEMail = false;
    let attendeeValidMobile = false;
    attendeeEMail !== "" ? attendeeValidEMail = true : attendeeValidEMail = false;
    attendeeMobile !== "" ? attendeeValidMobile = true : attendeeValidMobile = false;
    this.setState({
      attendeeUserId: userId,
      attendeeCorpId: attendee.corporateId ? attendee.corporateId : 0,
      attendeeTitle: attendeeTitle,
      attendeeIdentity: attendeeIdentity,
      attendeeFName: attendeeFName.trim(),
      attendeeLName: attendeeLName.trim(),
      attendeeMobile: attendeeMobile.trim(),
      attendeeCompany: attendeeCompany.trim(),
      attendeeEMail: attendeeEMail.trim(),
      attendeeValidMobile: attendeeValidMobile,
      attendeeValidEMail: attendeeValidEMail,
      attendeeValidIdentity: true,
      attendeeIdentifyType: identificationType,
      attendeeChange: attendeeIdentity === "" || attendeeFName === "" || attendeeLName === "" || attendeeMobile === "" || attendee.identificationType === null || attendee.title === null || attendeeEMail === ""
    });
  }

  submit = () => {
    this.state.meetingTitle.trim() === '' ? common.notifyMessage("Please enter meeting header") :
      this.state.meetingDescription.trim() === '' ? common.notifyMessage("Please enter meeting description") :
        this.state.meetingDate.trim() === '' ? common.notifyMessage("Please enter meeting date") :
          this.state.meetingSTime.trim() === '' ? common.notifyMessage("Please enter meeting start time") :
            this.state.meetingETime.trim() === '' ? common.notifyMessage("Please enter meeting end time") :
              (this.state.meetingSTime > this.state.meetingETime) ? common.notifyMessage("Meeting start time can't be greater than meeting end time") :
                this.state.meetingBuilding === '' ? common.notifyMessage("Please select meeting building") :
                  this.state.meetingFloor === '' ? common.notifyMessage("Please select meeting floor") :
                    this.state.meetingPurpose === '' ? common.notifyMessage("Please select meeting purpose") :
                      this.submit_();
  }

  submit_ = () => {
    if (this.state.repeatOpen) {
      this.state.meetingFrequency.trim() === '' ? common.notifyMessage("Please select meeting frequency") :
        this.state.meetingUntil.trim() === '' ? common.notifyMessage("Please enter end date of meeting repeat") :
          (this.state.meetingDate > this.state.meetingUntil) ? common.notifyMessage("Meeting date can't be greater than meeting until repeat date") :
            this.submit__();
    } else {
      this.submit__();
    }
  }

  gen_UID = () => {
    let ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let ID_LENGTH = 20;
    var rtn = '';
    for (var i = 0; i < ID_LENGTH; i++) {
      rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
    return rtn + "_" + "portal";
  };

  submit__ = () => {
    let cal = Job();
    let dateArray = (this.state.meetingDate).split("-");
    let timeArray = (this.state.meetingSTime).split(":");
    let untilArray = (this.state.meetingUntil).split("-");
    let days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
    let d = new Date(this.state.meetingDate);
    let dayName = days;
    if (this.state.meetingFrequency !== 'DAILY') {
      dayName = [days[d.getDay()]];
    }

    let rule = {
      freq: this.state.meetingFrequency,
      interval: 1,
      dtstart: this.state.meetingDate + " " + this.state.meetingSTime,
      until: this.state.meetingUntil,
      byday: dayName
    };

    let org_name = this.props.usr_obj.firstName + ' ' + this.props.usr_obj.firstName;
    let org_mail = this.props.usr_obj.email;
    let att_list = [];
    if (this.state.bulkVisitorsModalOpen){
      this.state.json.map((val, index) => {
        att_list.push(val.email);
      });
    } else {
      this.state.attendeesList.map((val, index) => {
        att_list.push(val.email);
      });
    }

    let genUID = this.gen_UID();

    let meetingIcs = "";

    let meetingDesc = this.state.meetingDescription.split(/\n/g).join("\\n");


    if (!this.state.repeatOpen) {
      try {
        // meetingIcs = cal.addEvent(this.state.meetingTitle, this.state.meetingDescription, this.props.usr_obj.corporates[0].corporateId,
        //   this.state.meetingDate+" "+this.state.meetingSTime, this.state.meetingDate+" "+this.state.meetingETime);

        meetingIcs = cal.addEvent(this.state.meetingTitle, meetingDesc, "location",
          this.state.meetingDate + " " + this.state.meetingSTime, this.state.meetingDate + " " + this.state.meetingETime, null, org_name, org_mail, att_list, 1, genUID);

        let meetingObj = {
          meeting: {
            refNo: genUID,
            hostA: this.state.hostId,
            floorId: this.state.meetingFloor,
            // floorId: 1,
            visitingPurpose: this.state.meetingPurpose,
            title: this.state.meetingTitle.trim(),
            description: meetingDesc.trim(),
            visitors: this.state.bulkVisitorsModalOpen ? this.state.json : this.state.attendeesList,
            icsContent: meetingIcs
          }
        }

        this.submit___(meetingObj);

      } catch (e) {
        notifyMessage("Something went wrong!", 1, 3);
      }

    } else {
      try {
        meetingIcs = cal.addEvent(this.state.meetingTitle, meetingDesc, this.props.usr_obj.corporates[0].corporateId,
          this.state.meetingDate + " " + this.state.meetingSTime, this.state.meetingDate + " " + this.state.meetingETime, rule, org_name, org_mail, att_list, 1, genUID);

        let meetingObj = {
          meeting: {
            refNo: genUID,
            hostA: this.state.hostId,
            floorId: this.state.meetingFloor,
            // floorId: 1,
            visitingPurpose: this.state.meetingPurpose,
            title: this.state.meetingTitle.trim(),
            description: meetingDesc.trim(),
            visitors: this.state.bulkVisitorsModalOpen ? this.state.json : this.state.attendeesList,
            icsContent: meetingIcs
          }
        }

        this.submit___(meetingObj);

      } catch (e) {
        notifyMessage("Something went wrong!", 1, 3);
      }

    }

  };

  submit___ = (meetingObj) => {
    swal({
      title: "Do you want to proceed",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.state.bulkVisitorsModalOpen ? this.sendBulkVisitorsToBackend(meetingObj) : this.sendToBackEnd(meetingObj);
            break;
          default:
        }
      });
  };

  sendBulkVisitorsToBackend = (meetingObj) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Content-Type": 'application/json',
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    axios.post(apiConfig.HOST_BULK_VISITORS_SCHEDULE_MEETING({corporateId: corporateId}),meetingObj,{headers:headers})
      .then(response => {
        let result = response.data.success;
        if (result) {
          this.cleanAttendeeFields();
          this.cleanMeetingFields();
          this.bulkVisitorsModalHandler();
          common.warningAlert("Meeting successfully saved", 0);
          this.props.callAllBuildings(this.props.usr_obj);
        } else {
          this.props.spinnerHandler(false);
          if (response.data.error_code === 720) {
            let errors = response.data.errors;
            this.setState({errorjson: errors})
          }
          common.warningAlert(response.data.message, 1)
        }
      }).catch(async error => {
        if (error.response.status === 417) {
          common.warningAlert("Something went wrong!", 1);
        } else {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            // this.sendToBackEnd();
          } else {
            this.props.spinnerHandler(false)
          }
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  }

  sendToBackEnd = (meetingObj) => {
    // set empty string to null value for identificationValue
    if(meetingObj.meeting.visitors.length > 0) {
      let visitorList = [];
      meetingObj.meeting.visitors.map(obj => {
        visitorList.push({
          ...obj,
          identificationValue: obj.identificationValue ? obj.identificationValue : null
        })
        meetingObj.meeting.visitors = visitorList;
      })
    }
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    this.props.spinnerHandler(true);
    axios.post(apiConfig.HOST_SCHEDULE_MEETING({corporateId: corporateId}), meetingObj, {headers: headers})
      .then(response => {
        let result = response.data.success;
        if (result) {
          this.cleanAttendeeFields();
          this.cleanAttendeeTbl();
          this.cleanMeetingFields();
          common.warningAlert("Meeting successfully saved", 0);
          this.props.callAllBuildings(this.props.usr_obj);
        } else {
          this.props.spinnerHandler(false);
          if (response.data.error_code === 720) {
            let errors = response.data.errors;
            this.setState({attendeeErrors: errors})
          }
          common.warningAlert(response.data.message, 1)
        }
      }).catch(async error => {
      if (error.response.status === 417) {
        common.warningAlert("Something went wrong!", 1);
      } else {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackEnd();
        } else {
          this.props.spinnerHandler(false)
        }
      }

    })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  }

  onHandleChangeHostMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcod.substr(1).replace(/\s/g, ""),condition);
    this.setState({
      valid_search_mobile:condition,
      search_mobile:value,
      attendeeSearch: withdialcod.substr(1).replace(/\s/g, "")
    });
  };

  identifyTypeOnChange = (e, { value }) => {
    this.setState({
      attendeeIdentifyType: value
    });
  };

  addChildrenAction = (type) => {
    let isvalid = false
    if (this.state.children_list.length !== 0) {
      this.state.children_list.map((item,i) => {
        if (item.title === '' || item.firstName === '' || item.lastName === '') {
          common.notifyMessage(this.state.visitor_info_type === 'ADULT' ? "Please fill all details of Child "+(i+1) :
            "Please fill all details of the child " );
          isvalid = true
        }
      })
    }
    if (!isvalid) {
      switch (type) {
        case 'add':
          this.state.children_list.push({title:'', firstName:'', lastName:''})
          this.forceUpdate()
          break;
        case 'save':
          this.state.visitor_info_type === 'ADULT' ? this.testMailValidation() : this.addAttendeeIntoQueue___()
          break;
      }
    }
  }

  handleChildrenList = (id,type,value) => {
    switch (type) {
      case "title":
        this.state.children_list[id].title = value
        break;
      case "firstName":
        this.state.children_list[id].firstName = value
        break;
      case "lastName":
        this.state.children_list[id].lastName = value
        break;
    }
    this.forceUpdate()
  }

  handleAdultChildBtn = (type) => {
    this.setState({ visitor_info_type:type })
    type === 'ADULT' ? this.setState({ children_list:[], attendeesList:[] }) :
      this.setState({ children_list:[{title:'', firstName:'', lastName:''}], attendeesList:[] })
  }

  removeChild = (id) => {
    this.state.children_list.splice(id,1);
    this.forceUpdate();
  }

  clockVisibleChanger = (value) => {
    switch (value) {
      case "S":
        this.setState({
          s_visible: true,
          e_visible: false
        });
        break;
      case "E":
        this.setState({
          s_visible: false,
          e_visible: true
        });
        break;
      case "SV":
        this.setState({
          s_visible: false,
        });
        break;
      case "EV":
        this.setState({
          e_visible: false
        });
        break;
    }
  };

  checkMeetingDetailsValidation = () => {
    this.state.meetingTitle.trim() === '' ? common.notifyMessage("Please enter meeting header") :
      this.state.meetingDescription.trim() === '' ? common.notifyMessage("Please enter meeting description") :
        this.state.meetingDate.trim() === '' ? common.notifyMessage("Please enter meeting date") :
          this.state.meetingSTime.trim() === '' ? common.notifyMessage("Please enter meeting start time") :
            this.state.meetingETime.trim() === '' ? common.notifyMessage("Please enter meeting end time") :
              (this.state.meetingSTime > this.state.meetingETime) ? common.notifyMessage("Meeting start time can't be greater than meeting end time") :
                this.state.meetingBuilding === '' ? common.notifyMessage("Please select meeting building") :
                  this.state.meetingFloor === '' ? common.notifyMessage("Please select meeting floor") :
                    this.state.meetingPurpose === '' ? common.notifyMessage("Please select meeting purpose") :
                      this.checkMeetingDetailsValidation_()
  }

  checkMeetingDetailsValidation_ = () => {
    if (this.state.repeatOpen) {
      this.state.meetingFrequency.trim() === '' ? common.notifyMessage("Please select meeting frequency") :
        this.state.meetingUntil.trim() === '' ? common.notifyMessage("Please enter end date of meeting repeat") :
          (this.state.meetingDate > this.state.meetingUntil) ? common.notifyMessage("Meeting date can't be greater than meeting until repeat date") :
            this.bulkVisitorsModalHandler();
    } else {
      this.bulkVisitorsModalHandler();
    }
  }

  bulkVisitorsModalHandler = () => {
    this.setState({bulkVisitorsModalOpen: !this.state.bulkVisitorsModalOpen})
  }

  onFilesChange = name => files => {
    if (files.length !== 0) {
        this.onFileChange(name, files[0]);
    } else {
      message.error("Please choose valid file type!");
    }
  };

  onFileChange = async (name, e) => {
    const textDataUrl = await readFile(e);
    this.setState({
      isSpin: false,
      [name]: textDataUrl,
      errorjson: [],
      validationErrors: [],
      visitors_bulk_rows: [],
      visitors_validation_error_rows: [],
      json: this.base64Decode(textDataUrl, "CSV")
    },() => {
      this.setFileDataToTable()
    });
  };

  setFileDataToTable = () => {
    if (this.state.json.length !== 0) {
      let visitor_rows = [];
      let validErrors = [];
      this.state.json.map((item, index) => {

        let identificationType = item.identificationType;
        let identificationValue = item.identificationValue;
        let mobileNo = item.mobile;
        let email = item.email;
        let tempValidIdentity = false;
        let tempValidMobile = false;
        let tempValidEmail = false;
        let duplicateIDValue = false;
        let duplicateMobile = false;
        let duplicateEmail = false;

        tempValidIdentity = util.identityValueValidator(identificationValue.trim(), identificationType.trim(), 1);
        tempValidMobile = util.mobileNumValidator(mobileNo.trim(),null,1);
        item.email? tempValidEmail = EmailValidator.validate(email.trim()) : tempValidEmail = true;

        if (item.title === "" || item.firstName === "" || item.lastName === "" || item.identificationType === "" || item.identificationValue === "" || item.mobile === "") {
          validErrors.push({
            row: index + 1,
            validIdentity: "",
            validMobile: "",
            validEmail: "",
            commonMessage: "Title, first name, last name, identification type, identification value and mobile can not be empty."
          })
        } else {
          if (!tempValidIdentity || !tempValidMobile || !tempValidEmail) {
            validErrors.push({
              row: index + 1,
              validIdentity: tempValidIdentity ? "" : "Invalid identification value",
              validMobile: tempValidMobile ? "" : "Invalid mobile number",
              validEmail: tempValidEmail ? "" : "Invalid email",
              commonMessage: ""
            })
          } else {
            for (let i = 0; i < this.state.json.length; i++) {
              if (index !== i) {
                if (item.identificationValue.trim().toLowerCase() === this.state.json[i].identificationValue.trim().toLowerCase()) {
                  duplicateIDValue = true;
                }
                if (item.mobile.trim() === this.state.json[i].mobile.trim()) {
                  duplicateMobile = true;
                }
                if (item.email.trim() !== "" && (item.email.trim().toLowerCase() === this.state.json[i].email.trim().toLowerCase())) {
                  duplicateEmail = true;
                }
              }
            }

            if (duplicateIDValue || duplicateMobile || duplicateEmail) {
              validErrors.push({
                row: index + 1,
                validIdentity: duplicateIDValue ? "Duplicate identification value" : "",
                validMobile: duplicateMobile ? "Duplicate mobile number" : "",
                validEmail: duplicateEmail ? "Duplicate email" : "",
                commonMessage: ""
              })
            }
          }
        }

        visitor_rows.push({
          rowNumber: index + 1,
          title: item.title,
          firstName: item.firstName,
          lastName: item.lastName,
          identificationType: identificationType,
          identificationValue: item.identificationValue,
          mobile: item.mobile,
          company: item.companyName,
          email: item.email
        })
      })


      this.setState({visitors_bulk_rows: visitor_rows, validationErrors: validErrors},() => {
        if (validErrors.length !== 0) {
          let validation_error_rows = [];
          validErrors.map((error, index) => {
            let validIdentity = error.validIdentity? error.validIdentity + " , " : "";
            let validMobile = error.validMobile? error.validMobile + " , " : "";
            let validEmail = error.validEmail? error.validEmail : "";
            let errorMessage = validIdentity + validMobile + validEmail;
            if (errorMessage.endsWith(", ")) {
              errorMessage = errorMessage.slice(0,-2);
            }
            validation_error_rows.push({
              cellNumber: error.row,
              cellMessage: error.commonMessage + errorMessage
            })
          })
          this.setState({visitors_validation_error_rows: validation_error_rows});
        }
      });
    }
  }

  base64Decode = (bytes, file) => {
    try {
      let split = bytes.split("base64,");
      let decode = base64.decode(split[1]);
      return this.csvToJson(decode);
    } catch (e) {
      console.log("exception", e);
      message.error("Please select " + file + " file!");
    }
  };

  csvToJson = (csv) => {
    try{
      this.setState({isSpin: true});
      let lines = csv.split("\n");
      let result = [];

      let headers = ["title","firstName","lastName","identificationType","identificationValue","mobile","companyName","email","userId"];
      for (let i = 1; i < lines.length; i++) {
        let obj = {};
        let currentline = lines[i].split(",");
        if (currentline.length > 1) {
          for (let j = 0; j < headers.length; j++) {
            if(headers[j] === "userId") {
              obj[headers[j]] = 0;
            } else if (headers[j] === "title") {
              let val = "";
              if (currentline[j].trim().toLowerCase() === "mr") {
                val = "Mr";
              } else if (currentline[j].trim().toLowerCase() === "mrs") {
                val = "Mrs";
              } else if (currentline[j].trim().toLowerCase() === "miss") {
                val = "Miss";
              } else if (currentline[j].trim().toLowerCase() === "ms") {
                val = "Ms";
              } else if (currentline[j].trim().toLowerCase() === "dr") {
                val = "Dr";
              } else if (currentline[j].trim().toLowerCase() === "ven") {
                val = "Ven";
              }
              obj[headers[j]] = val;
            } else if (headers[j] === "identificationType") {
              let val = "";
              if (currentline[j].trim() === "NIC" || currentline[j].trim() === "nic") {
                val = "NIC";
              } else if (currentline[j].trim() === "Driving Licence" || currentline[j].trim().toLowerCase().indexOf('driving') !== -1 || currentline[j].trim().toLowerCase().indexOf('licence') !== -1) {
                val = "Driving Licence";
              } else if (currentline[j].trim() === "Passport" || currentline[j].trim().toLowerCase().indexOf('passport') !== -1) {
                val = "Passport";
              }
              obj[headers[j]] = val;
            } else {
              let value = currentline[j].trim();
              obj[headers[j]] = value;
            }
          }
          if (obj[headers[0]] === "" && obj[headers[1]] === "" && obj[headers[2]] === "" && obj[headers[3]] === "" && obj[headers[4]] === "" && obj[headers[5]] === "" && obj[headers[6]] === "" && obj[headers[7]] === "") {

          } else {
            result.push(obj);
          }
        }
      }
      if (result.length === 0) {
        common.notifyMessage("Empty file!")
      }
      return result;
    }catch(error){
      common.notifyMessage("Invalid file!");
      return [];
    }
  };

  removeData = () => {
    swal({
      title: "Do you want to remove this data?",
      icon: are_you_sure_icon,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.setState({
              json: [],
              errorjson: [],
              validationErrors: [],
              visitors_bulk_rows: [],
              visitors_validation_error_rows: []
            });
            $("#bulk-visitors-tbl > tbody > tr").css("background-color", "white");
            break;
          default:
        }
      });
  }

  checkAttendeeDetailsValidation = () => {
    let identityValid = false;
    let mobileValid = false;
    let emailValid = false;
    let duplicateIDValue = false;
    let duplicateMobile = false;
    let duplicateEmail = false;
    let empty = false;

    this.state.json.some((item, index) => {
      identityValid = util.identityValueValidator(item.identificationValue, item.identificationType, 1);
      mobileValid = util.mobileNumValidator(item.mobile.trim(),null,1);
      item.email? emailValid = EmailValidator.validate(item.email.trim()) : emailValid = true;

      if (item.title === "" || item.firstName === "" || item.lastName === "" || item.identificationType === "" || item.identificationValue === "" || item.mobile === "") {
        empty = true;
        common.notifyMessage("Title, first name, last name, identification type, identification value and mobile can not be empty.");
        return true;
      }

      for (let i = 0; i < this.state.json.length; i++) {
        if (index !== i) {
          if (item.identificationValue.trim().toLowerCase() === this.state.json[i].identificationValue.trim().toLowerCase()) {
            duplicateIDValue = true;
          }
          if (item.mobile.trim() === this.state.json[i].mobile.trim()) {
            duplicateMobile = true;
          }
          if (item.email.trim() !== "" && (item.email.trim().toLowerCase() === this.state.json[i].email.trim().toLowerCase())) {
            duplicateEmail = true;
          }
        }
      }

      if (duplicateIDValue || duplicateMobile || duplicateEmail) {
        common.notifyMessage("Duplicate entries found.");
        return true;
      }

      if (!identityValid || !mobileValid || !emailValid) {
        common.notifyMessage("Please enter valid details");
        return true;
      }
      return false;
    })
    if (identityValid && mobileValid && emailValid && !duplicateIDValue && !duplicateMobile && !duplicateEmail && !empty) {
      this.submit__();
    }
  }

  // OnHandleChangeBuilding = (e, { value }) => {
  //   let selectedBuilding = this.props.all_building_list[value];
  //
  //   const floor_options = [];
  //   if (selectedBuilding.floors.length !== 0) {
  //     selectedBuilding.floors.map((element, index) => {
  //       floor_options.push({
  //         key: element.floor_id,
  //         text: element.description,
  //         value: element.floor_id,
  //         image: { avatar: true, src: floor_icon },
  //       })
  //     })
  //   }
  //
  //   this.setState({
  //     meeting_building: value,
  //     meeting_building_id: selectedBuilding.buildingId
  //   });
  //   this.props.receptionAllFloorHandler(floor_options);
  // };

  render() {
    let {visitors_bulk_rows} = this.state;
    let visitors_error_rows = [];
    let validation_error_rows = [];

    const options = [
      {key: '.com', text: '.com', value: '.com'},
      {key: '.net', text: '.net', value: '.net'},
      {key: '.org', text: '.org', value: '.org'},
    ]

    const optionsOfRecurrence = [
      {key: 'DAILY', text: 'DAILY', value: 'DAILY'},
      {key: 'WEEKLY', text: 'WEEKLY', value: 'WEEKLY'},
      {key: 'MONTHLY', text: 'MONTHLY', value: 'MONTHLY'},
      {key: 'YEARLY', text: 'YEARLY', value: 'YEARLY'},
    ]

    let meetingDateOnPicker = this.state.meetingDate !== "" ? moment(this.state.meetingDate, "YYYY-MM-DD") : null;
    let meetingSTimePicker = this.state.meetingSTime !== "" ? moment(this.state.meetingSTime, "HH:mm:ss") : null;
    let meetingETimePicker = this.state.meetingETime !== "" ? moment(this.state.meetingETime, "HH:mm:ss") : null;
    let meetingUntilOnPicker = this.state.meetingUntil !== "" ? moment(this.state.meetingUntil, "YYYY-MM-DD") : null;

    let recurrence_details = <div className="repeat-block">

      <Row className="">
        <Col lg={5} className="TimePickerCol">
          <Lbl required>Frequency</Lbl>
          <Dropdown
            placeholder='Select Frequency'
            fluid
            selection
            options={optionsOfRecurrence}
            onChange={this.onHandleChangeMeetingFrequency}/>
        </Col>
        <Col lg={6} className="TimePickerCol">
          <Lbl required>Until</Lbl>
          <DatePicker
            className="the-time-piker"
            disabledDate={this.disabledDateForUntil}
            disabled={this.state.meetingDate === '' ? true : false}
            style={{width: '100%'}} value={meetingUntilOnPicker}
            onChange={this.onHandleChangeUntil}/>
          {
            this.state.meetingDate === '' ?
              <span style={{color: "#ef5350"}}>*Please set meeting start date before set until date</span> : ""
          }

        </Col>
      </Row>

    </div>;

    let allBuildingsList = this.props.all_building_list;
    // let {visitors_purpose_options_list} = this.props;
    let visitors_purpose_options_list = this.props.purpose_options_list;
    const building_options = [];
    if (allBuildingsList.length !== 0) {
      allBuildingsList.map((element, index) => {
        building_options.push({
          key: index,
          text: element.name,
          value: index,
          image: {avatar: true, src: building_icon},
        })
      })
    }

    let attendees_col = [
      {
        label: 'Identification',
        field: 'id',
        sort: 'asc'
      },
      {
        label: 'First Name',
        field: 'fname',
        sort: 'asc'
      },
      {
        label: 'Last Name',
        field: 'lname',
        sort: 'asc'
      },
      {
        label: 'Mobile',
        field: 'mobile',
        sort: 'asc'
      },
      {
        label: 'Vehicle No',
        field: 'vehicleNo',
        sort: 'asc'
      },
      {
        label: 'Children',
        field: 'children',
        sort: 'asc'
      },
      {
        label: 'Remove',
        field: 'remove',
        sort: 'asc'
      }

    ];
    let attendees_rows = [];
      if (this.state.attendeesList.length !== 0) {
        this.state.attendeesList.map((attendee, index) => {
          let childrenString = ''
          if (attendee.children.length !== 0) {
            attendee.children.map(item => [
              childrenString += ", " + item.firstName + " " + item.lastName
            ])
            childrenString = childrenString.substring(1)
          }

          const obj = {
            id: attendee.identificationValue,
            fname: attendee.firstName,
            lname: attendee.lastName,
            mobile: attendee.mobile,
            vehicleNo: attendee.vehicleNumber,
            children: childrenString,
            remove:
              <Tooltip placement="topLeft" title={"Remove " + attendee.firstName}>
                <SementicBtn circular icon='trash alternate' className={"more-remove-card"}
                             onClick={() => this.removeAttendeeFormList(index, attendee)}
                />
              </Tooltip>
          };

          attendees_rows.push(obj);
        })
      }
    let attendees_table_data = {columns: attendees_col, rows: attendees_rows};

    let childrenDiv = []
    if (this.state.children_list.length !== 0) {
      this.state.children_list.map((item,index) => {
        let temp = index + 1
        childrenDiv.push(<div style={{marginTop:'2rem'}} key={index}>
          {this.state.visitor_info_type === 'ADULT' && <h6 style={{fontWeight:600}}>{"Child "+ temp}</h6>}
          <Row>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
              <LabelDropdown
                required
                // disable={this.state.isVisitor}
                tagText={"Title"}
                placeholder={"Select Title"}
                options={DropDownConst.userTitle}
                value={item.title}
                onChange={(e,{value}) => this.handleChildrenList(index,'title',value)}
              />
            </Col>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}></Col>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
              <LabelInput
                // disable={this.state.isVisitor}
                required
                tagText={"First Name"}
                placeholder={"First Name"}
                value={item.firstName}
                onChange={(e) => this.handleChildrenList(index,'firstName',e.target.value)}
              />
            </Col>

            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
              <LabelInput
                // disable={this.state.isVisitor}
                required
                tagText={"Last name"}
                placeholder={"Last name"}
                value={item.lastName}
                onChange={(e) => this.handleChildrenList(index,'lastName',e.target.value)}
              />
            </Col>
            {this.state.visitor_info_type === 'ADULT' && <Col>
              <div className='remove-child'><p><a onClick={() => this.removeChild(index)}>Remove</a></p></div>
            </Col>}
          </Row>
        </div>)
      })
    }

      if (this.state.errorjson.length !== 0) {
        this.state.errorjson.map((error,index) => {
          visitors_error_rows.push({
            cellNumber: error.row,
            cellMessage: error.message
          });

          $("#bulk-visitors-tbl > tbody > tr").each(function () {
            if ($(this).find('td').eq(0).text() === error.row.toString()) {
              $(this).css("background-color", "rgb(255,162,162)");
            }
          })

          /*let tbl_row = `#bulk-visitors-tbl > tbody > tr:nth-child(${error.row})`;
          $(tbl_row).css("background-color", "rgb(255,162,162)")*/
        })
      }

        if (this.state.visitors_validation_error_rows !== 0) {
          this.state.visitors_validation_error_rows.map((error, index) => {
            validation_error_rows.push({
              cellNumber: error.cellNumber,
              cellMessage: error.cellMessage
            })
          })
        }

    let bulk_visitors_table = {columns: visitors_col_bulk, rows: visitors_bulk_rows}
    let error_visitor_table_data = {columns: visitors_error_cols , rows: visitors_error_rows};
    let visitors_validation_error_tbl = {columns: visitors_error_cols, rows: validation_error_rows};

    /*setTimeout(()=> {
      if (this.state.visitors_validation_error_rows !== 0) {
        this.state.visitors_validation_error_rows.map((error, index) => {
          $("#bulk-visitors-tbl > tbody > tr").each(function () {
            if ($(this).find('td').eq(0).text() === error.cellNumber.toString()) {
              $(this).css("background-color", "rgb(255,162,162)");
            }
          })
        })
      }
    },100)*/


    return (
      <div>
        {
          this.state.bulkVisitorsModalOpen &&
          <MDBModal isOpen={this.state.bulkVisitorsModalOpen} toggle={() => {}} size="lg">
            <MDBModalHeader className={"title"} toggle={this.bulkVisitorsModalHandler}>Manage Bulk Visitors</MDBModalHeader>
            <MDBModalBody>

              <p className={"offline-warning-txt"}>(Download the <a href={csvFormat}>csv_format.csv</a> file. Modify the
                contents and upload)</p>
              <div id='bulk-file-div'>
                <Files
                  className='files-dropzone-bulk'
                  onChange={this.onFilesChange("file")}
                  accepts={["text/csv", ".csv"]}
                  multiple={false}
                  maxFileSize={10000000}
                  minFileSize={0}
                  clickable
                >
                  <button className={"file-uploader"}>Choose CSV file&nbsp;&nbsp;
                    <Icon name={"upload"}/>
                  </button>
                </Files>
              </div>

              <Spin spinning={this.state.isSpin} delay={10}
                    indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                <MDBDataTable
                  id={'bulk-visitors-tbl'}
                  responsive
                  responsiveSm
                  responsiveMd
                  responsiveLg
                  responsiveXl
                  bordered
                  hover
                  searching={false}
                  data={bulk_visitors_table}
                  ref={this.bulkTableRef}
                />
              </Spin>
              {
                this.state.json.length !== 0 &&
                <div align="center" style={{paddingTop:'2rem'}}>
                  <SementicBtn className={"bulk-submit-btn"} onClick={this.checkAttendeeDetailsValidation}>Submit</SementicBtn>
                  <SementicBtn onClick={this.removeData} className={"offline-remove-btn"} icon='trash alternate'/>
                </div>
              }
              {
                this.state.visitors_validation_error_rows.length !== 0 ?
                  <Row className={"none-margin"}>
                    <Col xs={12} className={"offline-error-title"}>
                      Errors at some rows
                    </Col>
                    <Col xs={12} className={"none-padding"}>
                      <MDBDataTable
                        responsive
                        responsiveSm
                        responsiveMd
                        responsiveLg
                        responsiveXl
                        entriesOptions={[5, 10, 20, 50]}
                        entries={5}
                        searching={false}
                        bordered
                        hover
                        data={visitors_validation_error_tbl}/>
                    </Col>
                    <br/><br/>
                  </Row> : null
              }
              {
                this.state.errorjson.length !== 0 ?
                  <Row className={"none-margin"}>
                    <Col xs={12} className={"offline-error-title"}>
                      Errors at some rows
                    </Col>
                    <Col xs={12} className={"none-padding"}>
                      <MDBDataTable
                        responsive
                        responsiveSm
                        responsiveMd
                        responsiveLg
                        responsiveXl
                        entriesOptions={[5, 10, 20, 50]}
                        entries={5}
                        searching={false}
                        bordered
                        hover
                        data={error_visitor_table_data}/>
                    </Col>
                    <br/><br/>
                  </Row> : null
              }


            </MDBModalBody>
          </MDBModal>
        }
        <h5 className="topicColor">Schedule a Meeting</h5>
        <Row className="main-row-padding">
          {/*--------------------------------------------------------------------------------------------------------------*/}
          <Col xs="12" lg={"6"} md={"12"}>
            <Card>
              <CardHeader>
                {/*Meeting Informations*/}
                MEETING INFORMATION
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <Row style={{padding: '10px'}}>

                    <Col lg={12}>

                      <Form>

                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"Meeting Header"}
                            placeholder={"Meeting Header"}
                            value={this.state.meetingTitle}
                            onChange={this.onHandleChange('meetingTitle')}
                          />
                        </Form.Group>

                        <Form.Group widths='equal' className={'flex-column'}>
                          <TxtAreaLbl
                            required
                            tagText={"Description"}
                            placeholder={"Description"}
                            maxLength={20001}
                            value={this.state.meetingDescription}
                            onChange={this.onHandleChange('meetingDescription')}
                          />
                          <div className={'d-flex'}>
                            <label className={'limit-exceed-label'}>{this.state.limitationError}</label>
                            <label className={'count-label'}>{this.state.meetingDescription.length + " / 20000"}</label>
                          </div>
                        </Form.Group>

                      </Form>
                      <Row className="TimePickerRow">
                        <Col lg={5} className="TimePickerCol">
                          <Lbl required>Meeting Date</Lbl>
                          <DatePicker
                            style={{width: '100%'}}
                            disabledDate={disabledDate}
                            value={meetingDateOnPicker}
                            onChange={this.onHandleMeetingDate}/>
                        </Col>
                        <Col lg={6} className="TimePickerCol">
                          <Row>
                            <Col lg={6} className="TimePickerCol modernTimePick">
                              <Lbl required>Start Time</Lbl>
                              <ModernTimePicker
                                unic= {"S"}
                                time={ this.state.meetingSTime }
                                change={ this.onHandleChangeSTime }
                                visible= {this.state.s_visible}
                                visi= { this.clockVisibleChanger } />
                              {/*<TimePicker
                                id={"id001x251"}
                                value={meetingSTimePicker}
                                onChange={this.onHandleChangeSTime}
                                // use12Hours
                                format="HH:mm"
                              />*/}
                            </Col>
                            <Col lg={6} className="TimePickerCol">
                              <Lbl required>End Time</Lbl>
                              <ModernTimePicker
                                unic= {"E"}
                                time={ this.state.meetingETime }
                                change={ this.onHandleChangeETime }
                                visible= {this.state.e_visible}
                                visi= { this.clockVisibleChanger } />
                              {/*<TimePicker
                                id={"id001x252"}
                                value={meetingETimePicker}
                                onChange={this.onHandleChangeETime}
                                // use12Hours
                                format="HH:mm"
                              />*/}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="TimePickerRow">
                        <Col lg={5} className="TimePickerCol">
                          <Lbl>Repeat<Icon name='sync alternate'/></Lbl>
                          <Checkbox toggle
                                    checked={this.state.repeatOpen}
                                    onChange={this.changeRepeatOpen}
                          />
                        </Col>
                      </Row>
                      {
                        this.state.repeatOpen ?
                          recurrence_details : ""
                      }
                      <Row className="TimePickerRow">
                        <Col lg={12} className="TimePickerCol">
                          <Lbl required>Meeting Building</Lbl>
                          <Dropdown
                            placeholder='Select Building'
                            fluid
                            selection
                            value={this.state.meetingBuilding}
                            options={building_options}
                            onChange={this.onHandleChangeBuilding}
                          />
                        </Col>
                      </Row>

                      <Row className="TimePickerRow">
                        <Col lg={12} className="TimePickerCol">
                          <Lbl required>Meeting Floor</Lbl>
                          <Dropdown
                            placeholder='Meeting Floor'
                            fluid
                            selection
                            value={this.state.meetingFloor}
                            options={this.state.meetingFloorList}
                            onChange={this.onHandleChangeFloor}
                          />
                        </Col>
                      </Row>

                      <Row className="TimePickerRow">
                        <Col lg={12} className="TimePickerCol">
                          <Lbl required>Meeting Purpose</Lbl>
                          <Dropdown
                            placeholder='Meeting Purpose'
                            fluid
                            selection
                            value={this.state.meetingPurpose}
                            options={visitors_purpose_options_list}
                            onChange={this.onHandleChangePurpose}
                          />
                        </Col>
                      </Row>

                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
          {/*--------------------------------------------------------------------------------------------------------------*/}
          <Col xs="12" lg={"6"} md={"12"}>
            <Card>
              <CardHeader>
                {/*Meeting Attendees*/}
                MEETING ATTENDEES
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <div className="minor-div">
                    <Button onClick={() => this.handleAdultChildBtn('ADULT')} className={this.state.visitor_info_type === 'ADULT' ? "active_btn" : "inactive_btn"}>Adult</Button>
                    <Button onClick={() => this.handleAdultChildBtn('CHILD')} className={this.state.visitor_info_type === 'CHILD' ? "active_btn" : "inactive_btn"}>Child</Button>
                    <hr/>
                  </div>

                  {
                    this.state.visitor_info_type  === 'ADULT' ? <>
                      <Form>
                        <Row>
                          <Col lg={"7"} md={"7"} sm={"7"} xs={"7"} className={'pr-0'}>
                            {
                              this.state.attendeeType === 'Mobile' ?
                                <div className={"display-inline"} id="mobile-input">
                                  <IntlTelInput
                                    style={{width: '100%'}}
                                    type={"text"}
                                    fieldName={"Mobile Number"}
                                    value={this.state.search_mobile}
                                    containerClassName="intl-tel-input dashboard-intl"
                                    inputClassName="form-control"
                                    onPhoneNumberChange={this.onHandleChangeHostMobile}
                                    required={true}
                                    preferredCountries={['lk']}
                                    defaultCountry={"lk"}
                                    nationalMode={false}
                                    icon='mobile alternate'
                                    placeholder="7XXXXXXXXX"
                                    // customPlaceholder={this.customPlaceholder}
                                  />
                                  <Dropdown
                                    style={{borderTopLeftRadius:0, borderBottomLeftRadius:0, display:'flex'}}
                                    button basic floating
                                    value={this.state.attendeeType}
                                    options={this.state.searchOptions}
                                    onChange={
                                      (e, {value}) => {
                                        this.setState({
                                          attendeeType: value, attendeeSearch:""
                                        })
                                      }
                                    }
                                  />
                                </div> :
                                <Input
                                  className="xx"
                                  action={
                                    <Dropdown
                                      button basic floating
                                      value={this.state.attendeeType}
                                      options={this.state.searchOptions}
                                      onChange={
                                        (e, {value}) => {
                                          this.setState({
                                            attendeeType: value, attendeeSearch:""
                                          })
                                        }
                                      }
                                    />
                                  }
                                  icon='search'
                                  iconPosition='left'
                                  placeholder='Search Here'
                                  value={this.state.attendeeSearch}
                                  onChange={this.onHandleChange("attendeeSearch")}
                                />
                            }
                          </Col>
                          <Col lg={"5"} md={"5"} sm={"5"} xs={"5"} className="d-flex align-items-center justify-content-between">
                            <SementicBtn onClick={this.searchAttendeeUsingIdentity} className="search-buttonx">Search</SementicBtn>
                            <SementicBtn onClick={this.checkMeetingDetailsValidation} basic color={'grey'} className={'bulk-visitors-buttonx'}>Bulk Visitors</SementicBtn>
                          </Col>
                        </Row>
                      </Form>
                      <br/>

                      {
                        this.state.search_mode && <>

                          <Row className="TimePickerRow">
                            <Col lg={6} className="TimePickerCol">
                              <Lbl required>Title</Lbl>
                              <Dropdown
                                placeholder='Select Title'
                                fluid
                                selection
                                value={this.state.attendeeTitle}
                                options={DropDownConst.userTitle}
                                // onChange={this.state.attendeeChange ? this.onHandleChangeAttendeeTitle : this.onHandleChangeAttendeeChange}
                                onChange={this.onHandleChangeAttendeeTitle}
                              />
                            </Col>
                            {
                              (this.state.attendeeType === 'Email' || this.state.attendeeType === 'Mobile') && <Col lg={6}></Col>
                            }
                            <Col lg={6} className="TimePickerCol">

                              <Form>

                                <Form.Group widths='equal' style={{paddingTop: "10px"}}>
                                  <TxtLbl
                                    required={true}
                                    tagText={"Identification"}
                                    placeholder={"Identification"}
                                    value={this.state.attendeeIdentity}
                                    // onChange={this.state.attendeeChange && (this.state.attendeeType === 'Email' || this.state.attendeeType === 'Mobile') ? this.onHandleChange('attendeeIdentity') : this.onHandleChangeAttendeeChange}
                                    onChange={this.state.attendeeType === 'Email' || this.state.attendeeType === 'Mobile' ? this.onHandleChange('attendeeIdentity') : this.onHandleChangeAttendeeChange}
                                  />
                                </Form.Group>
                              </Form>

                            </Col>
                            {
                              (this.state.attendeeType === 'Email' || this.state.attendeeType === 'Mobile') &&
                              <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
                                <Lbl required>Identity Type</Lbl>
                                <Dropdown
                                  placeholder='Select Type'
                                  fluid
                                  selection
                                  value={this.state.attendeeIdentifyType}
                                  options={DropDownConst.Identifications}
                                  // onChange={this.state.attendeeChange ? this.identifyTypeOnChange : this.onHandleChangeAttendeeChange}
                                  onChange={this.state.attendeeType === 'Email' || this.state.attendeeType === 'Mobile' ? this.identifyTypeOnChange : this.onHandleChangeAttendeeChange}
                                />
                              </Col>

                            }
                          </Row>

                          <Row className="TimePickerRow">
                            <Col lg={6} className="TimePickerCol">

                              <Form>

                                <Form.Group widths='equal'>
                                  <TxtLbl
                                    required
                                    tagText={"First Name"}
                                    placeholder={"First Name"}
                                    value={this.state.attendeeFName}
                                    // onChange={this.state.attendeeChange ? this.onHandleChange('attendeeFName') : this.onHandleChangeAttendeeChange}
                                    onChange={this.onHandleChange('attendeeFName')}
                                  />
                                </Form.Group>
                              </Form>

                            </Col>
                            <Col lg={6} className="TimePickerCol">

                              <Form>

                                <Form.Group widths='equal'>
                                  <TxtLbl
                                    required
                                    tagText={"Last Name"}
                                    placeholder={"Last Name"}
                                    value={this.state.attendeeLName}
                                    // onChange={this.state.attendeeChange ? this.onHandleChange('attendeeLName') : this.onHandleChangeAttendeeChange}
                                    onChange={this.onHandleChange('attendeeLName')}
                                  />
                                </Form.Group>
                              </Form>

                            </Col>
                          </Row>
                          <Row className="TimePickerRow">
                            <Col lg="6" md={"12"} sm={"12"} xs={"12"} style={{marginTop: '-12px'}}>
                              <Lbl style={{display: "block"}} required>Mobile</Lbl>
                              <IntlTelInput
                                id={"id001x253"}
                                style={{width: '100%'}}
                                type={"text"}
                                fieldName={"Mobile Number"}
                                value={this.state.attendeeMobile}
                                containerClassName="intl-tel-input dashboard-intl"
                                inputClassName="form-control"
                                // onPhoneNumberChange={this.state.attendeeChange && this.state.attendeeType !== 'Mobile' ? this.onHandleChangeAttendeeMobile : this.onHandleChangeAttendeeChange}
                                onPhoneNumberChange={this.state.attendeeType !== 'Mobile' ? this.onHandleChangeAttendeeMobile : this.onHandleChangeAttendeeChange}
                                required={true}
                                preferredCountries={['lk']}
                                defaultCountry={"lk"}
                                nationalMode={false}
                                customPlaceholder={this.onHandleCustomPlaceholderForAttendeeMobile}
                              />
                            </Col>
                            <Col lg={6} className="TimePickerCol">

                              <Form>

                                <Form.Group widths='equal'>
                                  <TxtLbl
                                    tagText={"Company"}
                                    placeholder={"Company"}
                                    value={this.state.attendeeCompany}
                                    // onChange={this.state.attendeeChange ? this.onHandleChange('attendeeCompany') : this.onHandleChangeAttendeeChange}
                                    onChange={this.onHandleChange('attendeeCompany')}
                                  />
                                </Form.Group>
                              </Form>

                            </Col>
                          </Row>
                          <Row className="TimePickerRow">
                            <Col lg={12} className="TimePickerCol">

                              <Form>

                                <Form.Group widths='equal'>
                                  <TxtLbl
                                    tagText={"Email"}
                                    placeholder={"Email"}
                                    value={this.state.attendeeEMail}
                                    // onChange={this.state.attendeeChange && this.state.attendeeType !== 'Email' ? this.onHandleChange('attendeeEMail') : this.onHandleChangeAttendeeChange}
                                    onChange={this.state.attendeeType !== 'Email' ? this.onHandleChange('attendeeEMail') : this.onHandleChangeAttendeeChange}
                                  />
                                </Form.Group>
                              </Form>

                            </Col>

                          </Row>
                          {/*<Row className="TimePickerRow">
                            <Col lg={12}  className="TimePickerCol">

                              <Form>

                                <Form.Group widths='equal'>
                                  <TxtLbl
                                    className={'vehicleNo_input'}
                                    tagText={"Vehicle No"}
                                    placeholder={"Vehicle No"}
                                    value={this.state.attendeeVehicleNo}
                                    onChange={this.onHandleChange('attendeeVehicleNo')}
                                  />
                                </Form.Group>
                              </Form>

                            </Col>

                          </Row>
                          <Row className="TimePickerRow">
                            <Col lg={12}  className="TimePickerCol">

                              <Form>

                                <Form.Group widths='equal'>
                                  <TxtLbl
                                    tagText={"Remark"}
                                    placeholder={"Remark"}
                                    value={this.state.attendeeRemark}
                                    onChange={this.onHandleChange('attendeeRemark')}
                                  />
                                </Form.Group>
                              </Form>

                            </Col>

                          </Row>
                          <Row>
                            <Col lg={12}>
                              <Checkbox style={{ fontWeight: '600',marginTop:'1rem', color: 'rgba(72, 72, 72, 0.87)!important' }}
                                        checked={this.state.enable_overdue} onChange={this.handleOverdueStatus} toggle
                                        label='Enable Overdue Message' />
                            </Col>
                          </Row>*/}

                          { childrenDiv }

                          <div className="add-child-div" onClick={() => this.addChildrenAction('add')}>
                            <Icon type="plus" style={{ fontSize: '16px', color: '#08c' }} theme="outlined"/>Add Children
                          </div>

                        </>
                      }


                      {
                        ((this.state.search_mode && this.state.visitor_info_type === 'ADULT') || this.state.visitor_info_type === 'CHILD') &&
                        <Row>
                          <Col sm={12} style={{padding: '0px', textAlign: 'right', marginBottom: '7px', marginLeft: '-10px'}}>
                            <SementicBtn icon
                                         onClick={this.addAttendeeIntoQueue}
                            >
                              <Icon name='angle down' className="animated infinite bounce delay-2s"/>
                              Add to Attendee queue
                            </SementicBtn>
                          </Col>
                        </Row>
                      }

                      {
                        this.state.attendeesList.length !== 0 ?
                          <Row>
                            <Col sm={12} style={{padding: '2px'}}>
                              <MDBDataTable
                                responsive
                                responsiveSm
                                responsiveMd
                                responsiveLg
                                responsiveXl
                                id={"visitors-details-table"}
                                paging={false}
                                searching={false}
                                bordered
                                hover
                                data={attendees_table_data}/>
                            </Col>
                          </Row>
                          : null
                      }



                    </> : <>
                      { childrenDiv }
                    </>
                  }


                  <Row>

                    {
                      this.state.attendeeErrors && this.state.attendeeErrors.length !== 0 &&
                      <Col sm={12} style={{marginBottom: '10px'}}>
                        <Message
                          negative
                          content={<List bulleted>{this.state.attendeeErrors.map(result => <List.Item><span
                            style={{fontWeight: "bold"}}>Attendee {result.row}</span>: {result.message}
                          </List.Item>)}</List>}
                        />
                      </Col>
                    }

                    {

                      this.state.attendeesList.length !== 0 || this.state.visitor_info_type === 'CHILD' ?
                        <Col sm={12} style={{padding: '10px', textAlign: "center"}}>
                          <SementicBtn
                            id="sbtn"
                            onClick={this.state.visitor_info_type === 'ADULT' ? this.submit : () => this.addChildrenAction('save')}>Submit</SementicBtn></Col> : null
                    }
                  </Row>

                </CardBody>
              </Collapse>
            </Card>
          </Col>
          {/*--------------------------------------------------------------------------------------------------------------*/}


        </Row>
      </div>


    );

  }

}

function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  visitors_offline_errors_lists: state.reception_SheduleMeetingReducer.visitors_offline_errors_lists,
  purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,
  all_building_list: state.reception_SheduleMeetingReducer.all_building_list,
  all_floor_list: state.reception_SheduleMeetingReducer.all_floor_list,
});

const visitors_col_bulk = [
  { label: 'Row Number', field: 'rowNumber'},
  { label: 'Title', field: 'title' },
  { label: 'First Name', field: 'firstName' },
  { label: 'Last Name', field: 'lastName' },
  { label: 'Identification Type', field: 'identificationType' },
  { label: 'Identification Value', field: 'identificationValue'},
  { label: 'Mobile', field: "mobile"},
  { label: "Company (optional)", field: "company"},
  { label: "Email (optional)", field: "email"}
];

const visitors_error_cols = [
  { label: 'Row Number', field: 'cellNumber'},
  { label: 'Error Message', field: 'cellMessage'},
];



const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildingsForHost(data)), // Get All Buildings Of Corporate
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
